import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", title: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true);
    try {
      await register(form);
      navigate("/home");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg-base)]">
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="flex items-center gap-2.5 mb-8 justify-center">
          <img
            src="/logo-talmia-ii.svg"
            alt="Talmia II"
            className="w-14 h-14 rounded-xl object-cover"
          />
          <span className="font-display text-xl font-bold">Talmia<span className="text-orange-400">II</span></span>
        </Link>

        <div className="card-dark p-7">
          <h1 className="font-display text-3xl font-bold mb-1">Create your account</h1>
          <p className="text-slate-400 text-sm mb-6">Join your team and start tracking work.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-xs text-slate-300 uppercase tracking-wider">Name</label>
                <input className="input-dark mt-1.5" required value={form.name} onChange={update("name")} data-testid="register-name-input" />
              </div>
              <div>
                <label className="text-xs text-slate-300 uppercase tracking-wider">Title</label>
                <input className="input-dark mt-1.5" placeholder="e.g. Engineer" value={form.title} onChange={update("title")} data-testid="register-title-input" />
              </div>
            </div>
            <div>
              <label className="text-xs text-slate-300 uppercase tracking-wider">Email</label>
              <input type="email" required className="input-dark mt-1.5" value={form.email} onChange={update("email")} data-testid="register-email-input" />
            </div>
            <div>
              <label className="text-xs text-slate-300 uppercase tracking-wider">Password</label>
              <input type="password" required minLength={6} className="input-dark mt-1.5" value={form.password} onChange={update("password")} data-testid="register-password-input" />
              <p className="text-[11px] text-slate-500 mt-1">Minimum 6 characters.</p>
            </div>
            {error && <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2" data-testid="register-error">{error}</div>}
            <button type="submit" disabled={loading} className="btn-coral w-full" data-testid="register-submit-button">
              {loading ? "Creating account..." : "Create account"}
            </button>
          </form>

          <p className="mt-5 text-sm text-slate-400 text-center">
            Already have an account? <Link to="/login" className="text-orange-400 hover:text-orange-300 font-medium" data-testid="link-to-login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
